<page-header [currentStep]="stage.current_stage.currentStep" [totalSteps]="totalSteps" [headerImage]="stage.current_stage.heading_image"></page-header>
<div class="container">
    <ng-container [ngSwitch]="stage.current_stage.reference">
        <div class="row">
            <div class="col-12" [ngClass]="(stage.current_stage.reference === 'tad_stage_outcome') ? 'col-md-12' : 'col-md-9 col-lg-7'">
                <div class="content">
                    <div *ngSwitchCase="'tad_stage_info'">
                        <together-auction-dip-info [incoming_case_id]="incoming_case_id" [stage]="stage" (stage_changing)="setStage($event)"></together-auction-dip-info>
                    </div>
                    <div *ngSwitchCase="'tad_stage_apply'">
                        <together-auction-dip-apply [incoming_case_id]="incoming_case_id" [stage]="stage" (parameters_added)="_addApplyParameters($event)"
                            (stage_changing)="setStage($event)"></together-auction-dip-apply>
                    </div>
                    <div *ngSwitchCase="'tad_stage_eligibility'">
                        <together-auction-dip-eligibility [incoming_case_id]="incoming_case_id" [stage]="stage" [property_type]="property_type" [is_dip]="is_dip"
                            (stage_changing)="setStage($event)"></together-auction-dip-eligibility>
                    </div>
                    <div *ngSwitchCase="'tad_stage_loan_details'">
                        <together-auction-dip-loan-details [incoming_case_id]="incoming_case_id" [stage]="stage" [property_type]="property_type"
                            [is_dip]="is_dip" (loan_details_updated)="_handleUpdatedLoanDetails($event)" (stage_changing)="setStage($event)"
                            (outgoing_case_id)="_handleUpdatedCaseId($event)"></together-auction-dip-loan-details>
                    </div>
                    <div *ngSwitchCase="'tad_stage_applicant_details'">
                        <together-auction-dip-applicant-details [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)">
                        </together-auction-dip-applicant-details>
                    </div>
                    <div *ngSwitchCase="'tad_stage_income_details'">
                        <together-auction-dip-income-details [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)">
                        </together-auction-dip-income-details>
                    </div>
                    <div *ngSwitchCase="'tad_stage_property_details'">
                        <together-auction-dip-property-details [stage]="stage" [is_dip]="is_dip" [incoming_case_id]="incoming_case_id" [property]="property_details"
                            (stage_changing)="setStage($event)" (updated_property_details)="_handleUpdatedPropertyDetails()">
                        </together-auction-dip-property-details>
                    </div>
                    <div *ngSwitchCase="'tad_stage_outcome'">
                        <together-auction-dip-outcome-details [propertyType]="property_type" [isDip]="is_dip" [stage]="stage" [incomingCaseId]="incoming_case_id"
                            (stageChanging)="setStage($event)"></together-auction-dip-outcome-details>
                    </div>
                    <div *ngSwitchCase="'tad_stage_additional_loan_details'">
                        <together-auction-dip-additional-details [stage]="stage" [is_dip]="is_dip" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)"></together-auction-dip-additional-details>
                    </div>
                    <div *ngSwitchCase="'tad_stage_solicitors_details'">
                        <together-auction-dip-solicitors-details [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)"></together-auction-dip-solicitors-details>
                    </div>
                    <!--
                <div *ngSwitchCase="'tad_stage_application_submitted'">
                    <together-auction-dip-outcome [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)">
                    </together-auction-dip-outcome>
                </div>
            -->
                    <div *ngSwitchCase="'tad_stage_login'">
                        <together-auction-dip-login [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)"></together-auction-dip-login>
                    </div>
                    <div *ngSwitchCase="'tad_stage_login_recap'">
                        <together-auction-dip-login-recap [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)"></together-auction-dip-login-recap>
                    </div>
                    <div *ngSwitchCase="'tad_stage_edit'">
                        <together-auction-dip-login-edit [stage]="stage" [incoming_case_id]="incoming_case_id" (stage_changing)="setStage($event)"></together-auction-dip-login-edit>
                    </div>
                    <div *ngSwitchCase="'tad_stage_dip_overview'">
                        <dip-overview [stage]="stage" [caseId]="incoming_case_id" (stageChanging)="setStage($event)">
                        </dip-overview>
                    </div>
                    <div *ngSwitchCase="'tad_stage_dip_submit'">
                        <dip-submission [stage]="stage" [caseId]="incoming_case_id" (stageChanging)="setStage($event)">
                        </dip-submission>
                    </div>
                    <div *ngSwitchCase="'tad_stage_application_overview'">
                        <application-overview [stage]="stage" [caseId]="incoming_case_id" (stageChanging)="setStage($event)">
                        </application-overview>
                    </div>
                    <div *ngSwitchCase="'tad_stage_application_submit'">
                        <application-submission [stage]="stage" [caseId]="incoming_case_id" (stageChanging)="setStage($event)">
                        </application-submission>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="content">
                    <div *ngSwitchCase="'tad_stage_application_outcome'">
                        <application-outcome [stage]="stage" [caseId]="incoming_case_id" (stageChanging)="setStage($event)">
                        </application-outcome>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
